import {
  styled,
  ButtonBase,
  AvatarGroup,
  avatarGroupClasses,
} from '@mui/material';

export const DashboardVariantV2GiverActionsWidgetActionButton = styled(
  ButtonBase,
)(({ theme }) => ({
  textAlign: 'left',
  backgroundColor: theme.palette.common.white,
  borderRadius: 12,
  padding: theme.spacing(1.5),
  justifyContent: 'space-between',
  gap: theme.spacing(1.5),
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
}));

export const DashboardVariantV2GiverActionsWidgetActionButtonImage = styled(
  'img',
)({
  transform: 'scale(1.8)',
  position: 'relative',
  objectFit: 'contain',
  width: 94,
  height: 43,
});

export const DashboardVariantV2GiverActionsWidgetActionAvatarGroup = styled(
  AvatarGroup,
)({
  [`& .${avatarGroupClasses.avatar}`]: {
    height: 48,
    width: 48,
  },
});
